import React, { memo } from 'react';
import DefaultAnswerLoading from '../AnswerLoading'; // 修改导入名称避免冲突
import MayAsk from '../MayAsk';
import { SortCompChild } from '../SubComp';
import './index.scss';
import Question from '../Question';
import FeedbackOperation from '../FeedbackOperation';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { StreamingText } from '@/pages/aigc/components/StreamingText';
import { useStallByText } from '../../hooks/useStallByText';

// 单独缓存 SortCompChild 的组件，避免对话 n-1 的数据都重新渲染
const MemoizedSortCompChild = memo(
  SortCompChild,
  (prevProps, nextProps) =>
    prevProps.messageId === nextProps.messageId &&
    !nextProps.isLastQA &&
    prevProps.isLastQA === nextProps.isLastQA,
);

// 单轮QA组件
const SingleQA = (props: any) => {
  const {
    question,
    isLastQA,
    onRecommendClick,
    streamingState,
    userInfo,
    scrollToBottom,
    setEditObj,
    editObj,
    messageId,
    handleSubmit,
    isProcessing,
    conversations,
    answer,
    fileList,
    setHaveEdit,
    setShowShareChatDialog,
    AnswerLoading: answerLoadingProp = DefaultAnswerLoading, // 添加默认值
    contentSingleQA,
    voiceActiveBar = 175,
    style,
    handleLikeOrDislike,
    customQuestion,
    custVoiceStyle,
    from,
    retrying,
    frontend_metadata: frontendMetadata,
  } = props;
  const stalled = useStallByText(answer, streamingState);
  return (
    <div
      className="dba-signle-qa"
      id={messageId ? `dba-qa-${messageId}` : undefined}
    >
      <Question
        question={question}
        userInfo={userInfo}
        setEditObj={setEditObj}
        editObj={editObj}
        setHaveEdit={setHaveEdit}
        editMessageId={editObj?.messageId}
        messageId={messageId}
        handleSubmit={handleSubmit}
        isProcessing={isProcessing}
        conversations={conversations}
        fileList={fileList}
        isLastQA={isLastQA}
        voiceActiveBar={voiceActiveBar}
        style={style}
        customQuestion={customQuestion}
        custVoiceStyle={custVoiceStyle}
        from={from}
        frontend_metadata={frontendMetadata}
      />
      {/* TODO: 这个dom结构还需再次优化 */}
      <div className="dba-answer">
        <div className="dba-process-box">
          <div
            className={classNames('dba-answer-content', {
              'dba-answer-content-isLastQA': isLastQA === null,
            })}
          >
            {contentSingleQA?.(props) || <MemoizedSortCompChild {...props} />}
            {streamingState === 'progressing' && isLastQA && stalled && (
              <StreamingText
                textColor="#838697"
                streamColor="#000000"
                fontSize="14px"
                duration={1.5}
                loop
                autoPlay
              />
            )}
            {streamingState === 'pending' &&
              isLastQA &&
              isEmpty(answer) &&
              React.createElement(answerLoadingProp, null)}
            {/* isLastQA=null 兼容分享页面不显示反馈区 */}
            {(isLastQA
              ? streamingState === 'complete' || !streamingState
              : isLastQA !== null) && (
              <div className={classNames('dba-answer-content-feedback')}>
                <FeedbackOperation
                  {...props}
                  question={question}
                  userInfo={userInfo}
                  setEditObj={setEditObj}
                  editObj={editObj}
                  messageId={messageId}
                  fileList={fileList}
                  handleSubmit={handleSubmit}
                  setShowShareChatDialog={setShowShareChatDialog}
                  handleLikeOrDislike={handleLikeOrDislike}
                  from={from}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <MayAsk
        messageId={messageId}
        scrollToBottom={scrollToBottom}
        question={question}
        isLastQA={isLastQA}
        streamingState={streamingState}
        onRecommendClick={onRecommendClick}
        answer={answer}
        AnswerLoading={answerLoadingProp}
        retrying={retrying}
      />
    </div>
  );
};

export default SingleQA;
